<template>
  <div
    class="message"
    style="
      width: 100%;
      word-break: break-word;
      position: relative;
      border-radius: 12px;
      max-width: 300px;
      overflow-wrap: break-word;
      min-height: 22px;
      min-width: 14px;
      overflow: hidden;
      margin-bottom: 5px;
      white-space: initial;
      padding: 4px;
    "
  >
    <v-card>
      <v-toolbar dense flat>
        <v-toolbar-title style="font-size: 16px">{{ treeView.heading }}</v-toolbar-title>
      </v-toolbar>

      <v-list dense>
        <v-list-group v-for="item in treeView.tree_view_items" :key="item.tree_view_text">
          <template #activator>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title style="font-size: 14px">{{
                  item.tree_view_text
                }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>

          <v-list-tile
            v-for="subItem in item.tree_view_children"
            :key="subItem.tree_view_children_text"
          >
            <v-list-tile-action style="min-width: 24px !important"></v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title style="font-size: 14px">{{
                subItem.tree_view_children_text
              }}</v-list-tile-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-icon>{{ subItem.action }}</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list-group>
      </v-list>
    </v-card>
  </div>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
      treeView: this.value
    }
  },

  watch: {
    value: {
      deep: true,
      handler() {
        this.treeView = this.value
      }
    }
  },
  mounted() {
    this.treeView = this.value
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/TreeViewViewer.vue